<template>
  <div>
    <error
      :message-store="messageStore"
      :pop-messages="popMessages"
      :show-messages="showMessages"
      :in-popup="this.inPopup"
      v-if="hasMessages"
    />
  </div>
</template>

<script>
import Error from './Error'

/**
 * @class FormError
 *
 * @description This is a wrapper component for Error.vue
 */
export default {
  name: 'form-error',
  components: {
    Error,
  },
  props: {
    showMessages: {
      type: Boolean,
      default: true,
    },
    inPopup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popMessages: {
        success: false,
        error: false,
        warning: false,
      },
    }
  },
  computed: {
    messageStore() {
      return this.$get('messages')
    },
    hasMessages() {
      return this.messageStore && this.messageStore.length > 0
    },
  },
}
</script>
